 /*
 Create By Sittikron : 26/06/2023
 Update By Sittikron : 09/08/2023 - แก้ไขหากไม่มีไฟล์รูปภาพให้แสดงภาพ Default และ แสดงข้อความ No Image 
                                  - เพิ่ม Permissionในการตรวจสอบ
 Update By Sittikron : 28/08/2023 - แก้ไขสิทธิทุกหน้า ที่เรียกการใช้  สิทธิ view  เปลี่ยนวิธีเขียนใหม่  ให้เหมือนหน้า m_project.js
 
 Update By POOM : 20/10/2023 - ปรับให้ Status แสดงแค่ label พอ ไม่ให้แก้ไข จากตรงนี้

 
 Update By POOM : 26/01/2024  เวลา return API    มีการใช้  status_ID === 0  ซึ่งผิด  แก้ให้ถูก คือ status_ID === 1

 Update By POOM : 30/01/2024  ให้ Weekend , Holiday  ไม่บังคับกรอกแล้ว  สามารถระบุ 00 หรือค่าว่างได้ทั้ง WT , OT
 Update By POOM : 2024-05-10  เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที

 Update BY POOM : 23-05-2024 
    - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล
  

*/

import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import {Class_ETC_MsgError,
        Class_ETC_MsgErrorfocusByID,
        Class_ETC_MsgSuccess, 
        convertTimeToMinutes,
        Class_ETC_SessionTimeOut
      } from "../Class/Class_Etc";
import MsgDescription from "../Class/MsgDescription.json";
import ConfigETC from "../Class/ConfigETC.json";
import axios from "axios";

import { CP_CheckPermission } from "../Class/Class_Permission"
import Pathurl from "../Class/Pathurl.json";

function M_configuration() {

  
  const isSVOT = CP_CheckPermission("service_list" , ["ot"],false,false);
  const [isFirst, setIsFirst] = useState(true);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);

  const [picture_str, setPicture_str] = useState(null);
  const [picture, setPicture] = useState(null);
  const [isPicture, setIsPicture] = useState(true);
  const [tagPicturetext, setTagPicturetext] = useState("");
  const [filepicture, setFilepicture] = useState(null);
  
  const [picture_str2, setPicture_str2] = useState(null);
  const [picture2, setPicture2] = useState(null);
  const [isPicture2, setIsPicture2] = useState(true);
  const [tagPicturetext2, setTagPicturetext2] = useState("");
  const [filepicture2, setFilepicture2] = useState(null); 

  const [isCompanyStatus, setIsCompanyStatus] = useState(true);
  const [selectedMondaywork, setSelectedMondaywork] = useState("-1");
  const [selectedTuesdaywork, setSelectedTuesdaywork] = useState("-1");
  const [selectedWednesdaywork, setSelectedWednesdaywork] = useState("-1");
  const [selectedThursdaywork, setSelectedThursdaywork] = useState("-1");
  const [selectedFridaywork, setSelectedFridaywork] = useState("-1");
  const [selectedSaturdaywork, setSelectedSaturdaywork] = useState("-1");
  const [selectedSundaywork, setSelectedSundaywork] = useState("-1");

  const [ defaultPicture ] = useState("../dist/img/default-150x150.png");
  const [ defaultPicture_str ] = useState("Choose file");

  const [isPermissionEdit, setIsPermissionEdit] = useState(false);

  //#region __ Checkbox __

  const onChange_Radio = (e , act ) => {
    if (act === "Monday")
    {
      setSelectedMondaywork(e.target.value)
    }
    else if (act === "Tuesday")
    {
      setSelectedTuesdaywork(e.target.value)
    }
    else if (act === "Wednesday")
    {
      setSelectedWednesdaywork(e.target.value)
    }
    else if (act === "Thursday")
    {
      setSelectedThursdaywork(e.target.value)
    }
    else if (act === "Friday")
    {
      setSelectedFridaywork(e.target.value)
    }
    else if (act === "Saturday")
    {
      setSelectedSaturdaywork(e.target.value)
    }
    else
    {
     setSelectedSundaywork(e.target.value)
    }
  }
  
  //#endregion

  //#region __ Open on load __

  useEffect(() => {
    if (isFirst === true) {
      GetConfig();
      if (isLoadedConfigData === true) { 
        let ckpermission = CP_CheckPermission("master" , ["configuration_view"] , false , true)
        if (ckpermission === true) {
          setIsPermissionEdit(CP_CheckPermission("master" , ["configuration_edit"] , false , false))
          setPicture(defaultPicture);
          setPicture_str(defaultPicture_str);    
          setPicture2(defaultPicture);
          setPicture_str2(defaultPicture_str); 
          Bind_Company(function() {
            setIsFirst(false);
            setIsLoadProgress(false);
          });
        }
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadedConfigData]);
  
  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  //#endregion
  
  //#region __ Bind Data__
  async function Bind_Company(_callback) {

    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = "";

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Company_Config_Get",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          // setPicture(json.com_img_display);
          if(json.com_img_display === ""){
            setPicture(defaultPicture);
            setTagPicturetext("No Image");
            setIsPicture(false);
          }else{
            setPicture(json.com_img_display);
            localStorage.setItem("com_img_display" , json.com_img_display);
            setIsPicture(true);
          }
          if(json.com_img_loading === ""){
            setPicture2(defaultPicture);
            setTagPicturetext2("No Image");
            setIsPicture2(false);
          }else{
            setPicture2(json.com_img_loading);
            localStorage.setItem("com_img_loading" , json.com_img_loading);
            setIsPicture2(true);
          }
          // setPicture2(json.com_img_loading);
          document.getElementById("hd_img_Display").value = json.com_img_display_str;
          document.getElementById("hd_img_Loading").value = json.com_img_loading_str;
          document.getElementById("txt_company_name").value = json.com_name;
          document.getElementById("txt_display_name").value = json.com_display;
          document.getElementById("txt_compay_code").value = json.com_code;
          document.getElementById("txt_compay_code").disabled = true;
          document.getElementById("work_day_WT").value = json.workday_WT;

          if (isSVOT)
          {
            document.getElementById("work_day_OT").value = json.workday_OT;
            document.getElementById("weekend_OT").value = json.weekend_OT;
            document.getElementById("holiday_OT").value = json.holiday_OT;
          }

          document.getElementById("weekend_WT").value = json.weekend_WT;
          document.getElementById("holiday_WT").value = json.holiday_WT;
          setIsCompanyStatus(json.com_status === 1 ? true : false);
          setSelectedMondaywork(json.day_Mon.toString());
          setSelectedTuesdaywork(json.day_Tue.toString());
          setSelectedWednesdaywork(json.day_Wed.toString());
          setSelectedThursdaywork(json.day_Thu.toString());
          setSelectedFridaywork(json.day_Fri.toString());
          setSelectedSaturdaywork(json.day_Sat.toString());
          setSelectedSundaywork(json.day_Sun.toString());
          if (_callback != null) {
              _callback();
          }
        } else {
          Class_ETC_MsgError(json.status_Desc, null);
          if (_callback != null) {
            _callback();
        }
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
    } catch {
      window.location.replace("../" + Pathurl.timesheet);
    }
  }

  //#endregion

  //#region __ Image __

   const handleCreateBase64 = useCallback(async (e) => {
    const file = e.target.files[0];
    const base64 = await convertToBase64(file);
    if (!file.name.match(/\.(jpg|jpeg|png|gif)$/)) 
    {
      Class_ETC_MsgError(MsgDescription.ERR007, null);
    } 
    else if (file.size > 5242880) 
    {
      Class_ETC_MsgError(MsgDescription.ERR008, null);
    } 
    else 
    {
      setPicture(base64);
      setPicture_str(file.name);
      setFilepicture(file);
      setIsPicture(true);
    }

    e.target.value = "";
  }, []);
  
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      if (!file) 
      {
        Class_ETC_MsgError(MsgDescription.ERR006, null);
      } 
      else 
      {
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
      }
      fileReader.onerror = (error) => 
      {
        reject(error);
      };
    });
  };

  const handleCreateBase64v2 = useCallback(async (e) => {
    const file = e.target.files[0];
    const base64 = await convertToBase64v2(file);
    if (!file.name.match(/\.(jpg|jpeg|png|gif)$/)) 
    {
      Class_ETC_MsgError(MsgDescription.ERR007, null);
    } 
    else if (file.size > 5242880) 
    {
      Class_ETC_MsgError(MsgDescription.ERR008, null);
    } 
    else 
    {
      setPicture2(base64);
      setPicture_str2(file.name);
      setFilepicture2(file);
      setIsPicture2(true);
    }

    e.target.value = "";
  }, []);
  
  const convertToBase64v2 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      if (!file) 
      {
        Class_ETC_MsgError(MsgDescription.ERR006, null);
      } 
      else 
      {
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
      }
      fileReader.onerror = (error) => 
      {
        reject(error);
      };
    });
  };

  //#endregion

  //#region __ Save Data __

  function Onclick_Save() {
    setIsLoadProgress(true);

    var istxtError = "";
    let isError = "";

    let workday_WT = convertTimeToMinutes(document.getElementById("work_day_WT").value.trim());
    workday_WT = isNaN(workday_WT)  ? "0" : workday_WT;

    let weekend_WT = convertTimeToMinutes(document.getElementById("weekend_WT").value.trim());
    weekend_WT = isNaN(weekend_WT)  ? "0": weekend_WT;
    let holiday_WT = convertTimeToMinutes(document.getElementById("holiday_WT").value.trim());
    holiday_WT = isNaN(holiday_WT)  ? "0": holiday_WT;

    let workday_OT = "0";
    let weekend_OT = "0";
    let holiday_OT = "0";


    let ck_work_day_OT = "";
    
    if (isSVOT)
    {
      workday_OT = convertTimeToMinutes(document.getElementById("work_day_OT").value.trim());
      workday_OT = isNaN(workday_OT)  ? "0": workday_OT;

      weekend_OT = convertTimeToMinutes(document.getElementById("weekend_OT").value.trim());
      weekend_OT = isNaN(weekend_OT)  ? "0": weekend_OT;

      holiday_OT = convertTimeToMinutes(document.getElementById("holiday_OT").value.trim());
      holiday_OT = isNaN(holiday_OT)  ? "0": holiday_OT;

      ck_work_day_OT = document.getElementById("work_day_OT").value
    }

    if (document.getElementById("txt_company_name").value.trim() === "") 
    {
      istxtError = "txt_company_name";
    } 
    else if (document.getElementById("txt_display_name").value === "") 
    {
      istxtError = "txt_display_name";
    }    
    //////////////////// WORKTIMECHECK /////////////////////////
    else if (document.getElementById("work_day_WT").value === "" && ck_work_day_OT === "") 
    {
      istxtError = "work_day_WT_";
    }
    else if (document.getElementById("work_day_WT").value === "00:00" && document.getElementById("work_day_OT").value === "00:00") 
    {
      istxtError = "work_day_WT>";
    }
    else if (workday_WT < 1 && workday_OT < 1) 
    {
      istxtError = "work_day_WT>";
    }
    else if (parseInt(workday_WT) + parseInt(workday_OT) > 1440)
    {
      istxtError = "work_day_WT";
    } 
    //////////////////// WEEKENDCHECK /////////////////////////
    // else if (document.getElementById("weekend_WT").value === "" && document.getElementById("weekend_OT").value === "") 
    // {
    //   istxtError = "weekend_WT_";
    // }   
    // else if (document.getElementById("weekend_WT").value === "00:00" && document.getElementById("weekend_OT").value === "00:00")  
    // {
    //   istxtError = "weekend_WT>";
    // }  
    // else if (weekend_WT < 1 && weekend_OT < 1) 
    // {
    //   istxtError = "weekend_WT>";
    // }
    else if (parseInt(weekend_WT) + parseInt(weekend_OT) > 1440)
    {
      istxtError = "weekend_WT";
    }
     //////////////////// HOLIDAYCHECK /////////////////////////
    // else if (document.getElementById("holiday_WT").value === "" && document.getElementById("holiday_OT").value === "") 
    // {
    //   istxtError = "holiday_WT_";
    // } 
    // else if (document.getElementById("holiday_WT").value === "00:00" && document.getElementById("holiday_OT").value === "00:00")  
    // {
    //   istxtError = "holiday_WT>";
    // } 
    // else if (holiday_WT < 1 && holiday_OT < 1) 
    // {
    //   istxtError = "holiday_WT>";
    // }
    else if (parseInt(holiday_WT) + parseInt(holiday_OT) > 1440)
    {
      istxtError = "holiday_WT";
    }
    if (istxtError !== "") 
    {
      isError = "Empty";
    }
    if (isError !== "") 
    {
      if (isError === "Empty") 
      {
        if (istxtError === "work_day_WT_" || istxtError === "weekend_WT_"|| istxtError === "holiday_WT_") 
        {
          setIsLoadProgress(false);
          Class_ETC_MsgErrorfocusByID(MsgDescription.ERR001, istxtError.slice(0, -1));
        }
        else if (istxtError === "work_day_WT>" || istxtError === "weekend_WT>"|| istxtError === "holiday_WT>") 
        {
          setIsLoadProgress(false);
          Class_ETC_MsgErrorfocusByID(MsgDescription.ERR018, istxtError.slice(0, -1));
        }
        else if (istxtError === "work_day_WT" || istxtError === "weekend_WT" || istxtError === "holiday_WT") 
        {
          setIsLoadProgress(false);
          Class_ETC_MsgErrorfocusByID(MsgDescription.ERR020, istxtError);
        } 
        else
        {
          setIsLoadProgress(false);
          Class_ETC_MsgErrorfocusByID(MsgDescription.ERR001, istxtError);
        }        
      } 
    } 
    else 
    {
      SaveEditcompany(workday_WT,workday_OT,weekend_WT,weekend_OT,holiday_WT,holiday_OT);
    }
  }

  function SaveEditcompany(workday_WT,workday_OT,weekend_WT,weekend_OT,holiday_WT,holiday_OT) {

    var txt_company_name = document.getElementById("txt_company_name").value.trim();
    var txt_display_name = document.getElementById("txt_display_name").value.trim();
    var com_img_display_str = document.getElementById("hd_img_Display").value.trim();
    var com_img_loading_str = document.getElementById("hd_img_Loading").value.trim();

    const formData = new FormData();
    formData.append("com_name",txt_company_name === "" ? "" : txt_company_name);
    formData.append("com_display",txt_display_name === "" ? "" : txt_display_name);

    formData.append("com_img_display_str",com_img_display_str === "" ? "" : com_img_display_str);
    formData.append("company_display_pic",filepicture === null ? null : filepicture);

    formData.append("com_img_loading_str",com_img_loading_str === "" ? "" : com_img_loading_str);
    formData.append("company_loading_pic",filepicture2 === null ? null : filepicture2);
    
    formData.append("workday_WT",workday_WT.toString() === "" ? "" : workday_WT.toString());
    formData.append("weekend_WT", weekend_WT.toString() === "" ? "" : weekend_WT.toString());
    formData.append("holiday_WT", holiday_WT.toString() === "" ? "" : holiday_WT.toString());

    formData.append("workday_OT",workday_OT.toString() === "" ? "" : workday_OT.toString());
    formData.append("weekend_OT", weekend_OT.toString() === "" ? "" : weekend_OT.toString());
    formData.append("holiday_OT", holiday_OT.toString() === "" ? "" : holiday_OT.toString());

    formData.append("day_Mon", selectedMondaywork === "" ? "" : selectedMondaywork);
    formData.append("day_Tue", selectedTuesdaywork === "" ? "" : selectedTuesdaywork);
    formData.append("day_Wed", selectedWednesdaywork === "" ? "" : selectedWednesdaywork);
    formData.append("day_Thu", selectedThursdaywork === "" ? "" : selectedThursdaywork);
    formData.append("day_Fri", selectedFridaywork === "" ? "" : selectedFridaywork);
    formData.append("day_Sat", selectedSaturdaywork === "" ? "" : selectedSaturdaywork);
    formData.append("day_Sun", selectedSundaywork === "" ? "" : selectedSundaywork);
    
    formData.append("com_status", isCompanyStatus === true ? "1" : "0");
    
    let token = localStorage.getItem("TStoken");

    let config = 
    {
      method: "post",
      maxBodyLength: Infinity,
      url: configData.API_URL + "Company_Config_Edit",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + token,
      },
      data: formData,
      contentType: false, // Not to set any content header
      processData: false, // Not to process data
      async: false,
      traditional: true,
    };

    axios.request(config)
      .then((result) => {

        if (result.data.status_ID === 1) 
        {
          Bind_Company(function() {
            setPicture_str(defaultPicture_str);    
            setPicture_str2(defaultPicture_str); 
            setIsLoadProgress(false);
            Class_ETC_MsgSuccess(MsgDescription.CFM001, null);
          });
        } 
        else if (result.data.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else 
        {
          setIsLoadProgress(false);
          Class_ETC_MsgError(result.data.status_Desc, null);
        }
      })
      .catch((error) => {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR002, null);
      });
  }

  //#endregion

  //#region __ Cancel click __

  function onclickCancel(){
    setIsLoadProgress(true);
    Bind_Company(function() {
        setPicture_str(defaultPicture_str);    
        setPicture_str2(defaultPicture_str); 
        setIsLoadProgress(false);
      });
  }

  //#endregion

  return (
    <>

      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}

      <Helmet>
        <title>Company Setting</title>
      </Helmet>

    {/* Content Wrapper. Contains page content */}
    <div className="content-wrapper">
      {/* Content Header (Page header) */}
      <div className="content-header">
        <div className="row">
          <div className="col-md-10 offset-md-1">
            <div className="container-fluid">
              <h1 className="display-5"> <i className="fas fa-wrench" /> Company Setting </h1>
            </div>
          </div>
        </div>
      </div>
      {/* /.content-header */}
      {/* Main content */}
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              {/* SELECT2 EXAMPLE */}
              <div className="card  shadow">
                <div className="card-header">
                  <h3 className="card-title"> Company setting</h3>
                </div>
                <div className="card-body">
                  <div className="form-horizontal">

                    <div className="row">
                      <div className="col-lg-6 col-12">
                          <div className="form-group row mb-1">
                            <input type="hidden" id="hd_img_Display"></input>
                            {(isPicture === false && (
                                <>
                                  <div
                                    className="profile-user-img img-fluid img-circle img-bordered-sm bg-gray text-center"
                                    style={{
                                      display: "inline-block",
                                      height: "100px",
                                      width: "100px",                              
                                    }}
                                  >
                                    <i className="fa" title="logo" style={{fontSize: "15px",padding:"28px",}}>{tagPicturetext}</i>
                                  </div> 
                                </>
                            ))
                            ||
                            (isPicture === true &&(
                              <>
                              <img
                                className="profile-user-img img-fluid img-circle"
                                src={picture}
                                id="img_display_picture"
                                alt="logo"
                              />
                              </>
                            ))                  
                            }
                            {/* <img
                                className="profile-user-img img-fluid"
                                src={picture}
                                id="img_display_picture"
                                alt="logo"
                              /> */}
                          </div>
                          <div className="form-group row">
                          <label htmlFor="exampleInputFile" className="text-sm col-sm-4 col-form-label text-right">Display Picture</label>
                            <div className="col-sm-8">
                              <div className="input-group">
                                <div className="custom-file">
                                  <input 
                                    type="file" 
                                    className="custom-file-input form-control-sm" 
                                    id="img_display_picture_str" 
                                    accept="image/*, png, jpeg, jpg, gif"
                                    onChange={handleCreateBase64}
                                  />
                                  <label className="custom-file-label">{picture_str}</label>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                      <div className="col-lg-6 col-12">
                          <div className="form-group row mb-1">
                          <input type="hidden" id="hd_img_Loading"></input>
                          {(isPicture2 === false && (
                              <>
                                <div
                                  className="profile-user-img img-fluid img-circle img-bordered-sm bg-gray text-center"
                                  style={{
                                    display: "inline-block",
                                    height: "100px",
                                    width: "100px",                              
                                  }}
                                >
                                  <i className="fa" title="logo" style={{fontSize: "15px",padding:"28px",}}>{tagPicturetext2}</i>
                                </div> 
                              </>
                          ))
                          ||
                          (isPicture2 === true &&(
                            <>
                            <img
                              className="profile-user-img img-fluid img-circle"
                              src={picture2}
                              id="img_display_picture2"
                              alt="logo"
                            />
                            </>
                          ))                  
                          }
                          {/* <img
                          className="profile-user-img img-fluid"
                          src={picture2}
                          id="img_loading_picture"
                          alt="logo"
                        /> */}
                          </div>
                          <div className="form-group row">

                          <label htmlFor="exampleInputFile" className="text-sm col-sm-4 col-form-label text-right">Loading Picture</label>
                      <div className="col-sm-8">
                        <div className="input-group">
                          <div className="custom-file">
                          <input 
                              type="file" 
                              className="custom-file-input form-control-sm" 
                              id="img_loading_picture_str" 
                              accept="image/*, png, jpeg, jpg, gif"
                              onChange={handleCreateBase64v2}
                            />
                            <label className="custom-file-label">{picture_str2}</label>
                          </div>
                        </div>
                      </div>

                          </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="text-sm col-sm-2 col-form-label text-right">Company name<span className="text-danger">*</span></label>
                      <div className="col-sm-10">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Company Name"
                          id="txt_company_name"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="text-sm col-sm-2 col-form-label text-right">Display name<span className="text-danger">*</span></label>
                      <div className="col-sm-10">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Display Name"
                          id="txt_display_name"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="text-sm col-sm-2 col-form-label text-right">Company Code</label>
                      <div className="col-sm-4">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Company Code"
                            id="txt_compay_code"
                          />
                        {/* <div className="input-group">
                          <div className="form-control form-control-sm">
                            {isComcode}
                          </div>
                        </div> */}
                      </div>
                      <label className="text-sm col-sm-2 col-form-label text-right"></label>
                      <div className="col-sm-4">
                        {/* เว้นเอาไว้ไม่ให้เสีย CSS*/}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6 col-12">
                        <div className="form-group row">
                          <label className="text-sm col-sm-4 col-form-label text-right">Work day<span className="text-danger">*</span><small>(hr./day)</small> </label>
                          <div className="col-sm-4">
                            <div className="input-group">
                              <input type="text" 
                                     className="form-control form-control-sm" 
                                     id="work_day_WT" 
                                     name="work_day_WT" 
                                     placeholder="00:00" 
                                     data-inputmask-alias="datetime" 
                                     data-inputmask-inputformat="HH:MM" 
                                     data-inputmask-placeholder="00:00" 
                              />
                              <div className="input-group-append">
                                <span className="input-group-text text-smaller"><i className="far fa-clock" title="Work time" />&nbsp;WT </span>
                              </div>
                            </div>
                          </div>

                          {isSVOT &&
                          
                          <div className="col-sm-4">
                            <div className="input-group">
                              <input type="text" 
                                     className="form-control form-control-sm" 
                                     id="work_day_OT" 
                                     name="work_day_OT" 
                                     placeholder="00:00" 
                                     data-inputmask-alias="datetime" 
                                     data-inputmask-inputformat="HH:MM" 
                                     data-inputmask-placeholder="00:00" 
                                />
                              <div className="input-group-append">
                                <span className="input-group-text text-smaller"><i className="far fa-lightbulb" title="Over time" />&nbsp;OT </span>
                              </div>
                            </div>
                          </div>

                        }


                        </div>
                        <div className="form-group row">
                          <label className="text-sm col-sm-4 col-form-label text-right">Weekend<small>(hr./day)</small></label>
                          <div className="col-sm-4">
                            <div className="input-group">
                            <input type="text" 
                                     className="form-control form-control-sm" 
                                     id="weekend_WT" 
                                     name="weekend_WT" 
                                     placeholder="00:00" 
                                     data-inputmask-alias="datetime" 
                                     data-inputmask-inputformat="HH:MM" 
                                     data-inputmask-placeholder="00:00"  
                                />
                              <div className="input-group-append">
                                <span className="input-group-text text-smaller"><i className="far fa-clock" title="Work time" />&nbsp;WT </span>
                              </div>
                            </div>
                          </div>

                          {isSVOT &&
                          <div className="col-sm-4">
                            <div className="input-group">
                                <input type="text" 
                                     className="form-control form-control-sm" 
                                     id="weekend_OT" 
                                     name="weekend_OT" 
                                     placeholder="00:00" 
                                     data-inputmask-alias="datetime" 
                                     data-inputmask-inputformat="HH:MM" 
                                     data-inputmask-placeholder="00:00"  
                                />
                              <div className="input-group-append">
                                <span className="input-group-text text-smaller"><i className="far fa-lightbulb" title="Over time" />&nbsp;OT </span>
                              </div>
                            </div>
                          </div>
                          }



                        </div>
                        <div className="form-group row">
                          <label className="text-sm col-sm-4 col-form-label text-right">Holiday<small>(hr./day)</small></label>
                          <div className="col-sm-4">
                            <div className="input-group">
                                <input type="text" 
                                     className="form-control form-control-sm" 
                                     id="holiday_WT" 
                                     name="holiday_WT" 
                                     placeholder="00:00" 
                                     data-inputmask-alias="datetime" 
                                     data-inputmask-inputformat="HH:MM" 
                                     data-inputmask-placeholder="00:00"  
                                />
                              <div className="input-group-append">
                                <span className="input-group-text text-smaller"><i className="far fa-clock" title="Work time" />&nbsp;WT </span>
                              </div>
                            </div>
                          </div>

                          {isSVOT &&
                          <div className="col-sm-4">
                            <div className="input-group">
                                <input type="text" 
                                     className="form-control form-control-sm" 
                                     id="holiday_OT" 
                                     name="holiday_OT" 
                                     placeholder="00:00" 
                                     data-inputmask-alias="datetime" 
                                     data-inputmask-inputformat="HH:MM" 
                                     data-inputmask-placeholder="00:00"  
                                />
                              <div className="input-group-append">
                                <span className="input-group-text text-smaller"><i className="far fa-lightbulb" title="Over time" />&nbsp;OT </span>
                              </div>
                            </div>
                          </div>
                          }



                        </div>
                        <div className="form-group row">
                          <label className="text-sm col-sm-4 col-4  col-form-label text-right">Status </label>
                          <div className="col-sm-4 col-4 ">
                            <span className={isCompanyStatus === true ? ConfigETC.Status_active : ConfigETC.Status_inactive} >
                              {isCompanyStatus === true ? ConfigETC.SwitchButton_active_text : ConfigETC.SwitchButton_inactive_text}
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* Mon - Sun */}
                      <div className="col-lg-6 col-12">
                        <div className="form-group row m-0">
                          <label className="text-sm col-sm-4 col-4 text-right">Monday</label>
                          <div className="col-sm-4 col-4 ">
                            <div className="form-group clearfix p-0">
                              <div className="icheck-primary d-inline">
                                    <input
                                          type="radio"
                                          id="chk_work_Monday"
                                          value="1"
                                          name="chk_Monday"
                                          checked={selectedMondaywork === "1"}
                                          onChange={(e) => onChange_Radio(e , "Monday")} 
                                    />
                                <label htmlFor="chk_work_Monday">
                                  <span><small>Work day</small></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4 col-4 ">
                            <div className="icheck-primary d-inline">
                                    <input
                                          type="radio"
                                          id="chk_weekend_Monday"
                                          value="0"
                                          name="chk_Monday"
                                          checked={selectedMondaywork === "0"}
                                          onChange={(e) => onChange_Radio(e , "Monday")} 
                                    />
                              <label htmlFor="chk_weekend_Monday">
                                <span><small>Weekend</small></span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group row m-0">
                          <label className="text-sm col-sm-4 col-4  text-right">Tuesday</label>
                          <div className="col-sm-4 col-4 ">
                            <div className="form-group clearfix p-0">
                              <div className="icheck-primary d-inline">
                                    <input
                                          type="radio"
                                          id="chk_work_Tuesday"
                                          value="1"
                                          name="chk_Tuesday"
                                          checked={selectedTuesdaywork === "1"}
                                          onChange={(e) => onChange_Radio(e , "Tuesday")} 
                                    />
                                <label htmlFor="chk_work_Tuesday">
                                  <span><small>Work day</small></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4 col-4 ">
                            <div className="icheck-primary d-inline">
                                    <input
                                          type="radio"
                                          id="chk_weekend_Tuesday"
                                          value="0"
                                          name="chk_Tuesday"
                                          checked={selectedTuesdaywork === "0"}
                                          onChange={(e) => onChange_Radio(e , "Tuesday")} 
                                    />
                              <label htmlFor="chk_weekend_Tuesday">
                                <span><small>Weekend</small></span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group row m-0">
                          <label className="text-sm col-sm-4 col-4  text-right">Wednesday</label>
                          <div className="col-sm-4 col-4 ">
                            <div className="form-group clearfix p-0">
                              <div className="icheck-primary d-inline">
                                    <input
                                          type="radio"
                                          id="chk_work_Wednesday"
                                          value="1"
                                          name="chk_Wednesday"
                                          checked={selectedWednesdaywork === "1"}
                                          onChange={(e) => onChange_Radio(e , "Wednesday")} 
                                    />
                                <label htmlFor="chk_work_Wednesday">
                                  <span><small>Work day</small></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4 col-4 ">
                            <div className="icheck-primary d-inline">
                                    <input
                                          type="radio"
                                          id="chk_weekend_Wednesday"
                                          value="0"
                                          name="chk_Wednesday"
                                          checked={selectedWednesdaywork === "0"}
                                          onChange={(e) => onChange_Radio(e , "Wednesday")} 
                                    />
                              <label htmlFor="chk_weekend_Wednesday">
                                <span><small>Weekend</small></span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group row m-0">
                          <label className="text-sm col-sm-4 col-4  text-right">Thursday</label>
                          <div className="col-sm-4 col-4 ">
                            <div className="form-group clearfix p-0">
                              <div className="icheck-primary d-inline">
                                    <input
                                          type="radio"
                                          id="chk_work_Thursday"
                                          value="1"
                                          name="chk_Thursday"
                                          checked={selectedThursdaywork === "1"}
                                          onChange={(e) => onChange_Radio(e , "Thursday")} 
                                    />
                                <label htmlFor="chk_work_Thursday">
                                  <span><small>Work day</small></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4 col-4 ">
                            <div className="icheck-primary d-inline">
                                    <input
                                          type="radio"
                                          id="chk_weekend_Thursday"
                                          value="0"
                                          name="chk_Thursday"
                                          checked={selectedThursdaywork === "0"}
                                          onChange={(e) => onChange_Radio(e , "Thursday")} 
                                    />
                              <label htmlFor="chk_weekend_Thursday">
                                <span><small>Weekend</small></span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group row m-0">
                          <label className="text-sm col-sm-4 col-4  text-right">Friday</label>
                          <div className="col-sm-4 col-4 ">
                            <div className="form-group clearfix p-0">
                              <div className="icheck-primary d-inline">
                                    <input
                                          type="radio"
                                          id="chk_work_Friday"
                                          value="1"
                                          name="chk_Friday"
                                          checked={selectedFridaywork === "1"}
                                          onChange={(e) => onChange_Radio(e , "Friday")} 
                                    />
                                <label htmlFor="chk_work_Friday">
                                  <span><small>Work day</small></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4 col-4 ">
                            <div className="icheck-primary d-inline">
                                    <input
                                          type="radio"
                                          id="chk_weekend_Friday"
                                          value="0"
                                          name="chk_Friday"
                                          checked={selectedFridaywork === "0"}
                                          onChange={(e) => onChange_Radio(e , "Friday")} 
                                    />
                              <label htmlFor="chk_weekend_Friday">
                                <span><small>Weekend</small></span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group row m-0">
                          <label className="text-sm col-sm-4 col-4  text-right">Saturday</label>
                          <div className="col-sm-4 col-4 ">
                            <div className="form-group clearfix p-0">
                              <div className="icheck-primary d-inline">
                                    <input
                                          type="radio"
                                          id="chk_work_Saturday"
                                          value="1"
                                          name="chk_Saturday"
                                          checked={selectedSaturdaywork === "1"}
                                          onChange={(e) => onChange_Radio(e , "Saturday")} 
                                    />
                                <label htmlFor="chk_work_Saturday">
                                  <span><small>Work day</small></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4 col-4 ">
                            <div className="icheck-primary d-inline">
                                    <input
                                          type="radio"
                                          id="chk_weekend_Saturday"
                                          value="0"
                                          name="chk_Saturday"
                                          checked={selectedSaturdaywork === "0"}
                                          onChange={(e) => onChange_Radio(e , "Saturday")} 
                                    />
                              <label htmlFor="chk_weekend_Saturday">
                                <span><small>Weekend</small></span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group row m-0">
                          <label className="text-sm col-sm-4 col-4  text-right">Sunday</label>
                          <div className="col-sm-4 col-4 ">
                            <div className="form-group clearfix p-0">
                              <div className="icheck-primary d-inline">
                                    <input
                                          type="radio"
                                          id="chk_work_Sunday"
                                          value="1"
                                          name="chk_Sunday"
                                          checked={selectedSundaywork === "1"}
                                          onChange={(e) => onChange_Radio(e , "Sunday")} 
                                    />
                                <label htmlFor="chk_work_Sunday">
                                  <span><small>Work day</small></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4 col-4 ">
                            <div className="icheck-primary d-inline">
                                    <input
                                          type="radio"
                                          id="chk_weekend_Sunday"
                                          value="0"
                                          name="chk_Sunday"
                                          checked={selectedSundaywork === "0"}
                                          onChange={(e) => onChange_Radio(e , "Sunday")} 
                                    />
                              <label htmlFor="chk_weekend_Sunday">
                                <span><small>Weekend</small></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.card-body */}
                <div className="card-footer margin  ">
                  <a href="#!" 
                     className="btn btn-default "
                     onClick={() => onclickCancel()}
                  >
                    <i className="fa  fa-times" /> Cancel
                  </a>
                  {(isPermissionEdit === true) &&
                    <a 
                      href="#!"
                      className="btn btn-primary float-right "
                      onClick={() => Onclick_Save()}
                    >
                      <i className="fas  fa-save" /> Save
                    </a>
                  }
                </div>
                {/* end loading */}
              </div>
            </div>
          </div>           
        </div>{/* /.container-fluid */}
      </section>
      {/* /.content */}
    </div>
    {/* /.content-wrapper */}

    </>
  );
}

export default M_configuration;
